import { motion } from "framer-motion";
import { Cpu, FileText, Check } from "lucide-react";
import { IMAGES } from "@/lib/site";
import { TiltCard } from "@/components/site/TiltCard";

const services = [
  {
    icon: Cpu,
    title: "IT Strategy & Consulting",
    image: IMAGES.itStrategy,
    testId: "service-it-strategy",
    desc: "From cloud migration to architecture reviews, we align technology decisions with business outcomes so your infrastructure scales without surprises.",
    points: ["Cloud architecture & migration", "Cost & performance optimization", "Security & reliability reviews"],
  },
  {
    icon: FileText,
    title: "Technical Writing",
    image: IMAGES.techWriting,
    testId: "service-tech-writing",
    desc: "Clear documentation that accelerates adoption. We turn complex systems, APIs, and processes into content engineers and stakeholders can act on.",
    points: ["API & developer documentation", "System design & runbooks", "Knowledge base & onboarding guides"],
  },
];

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 px-6 md:px-12 lg:px-16 border-t border-gray-200">
      <div className="mx-auto max-w-[1400px]">
        <div className="max-w-2xl mb-16">
          <p className="text-xs tracking-[0.25em] uppercase font-bold text-gray-500 mb-4">What we do</p>
          <h2 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter text-[#0A0A0A]">
            Two disciplines,
            <br />
            one standard of precision.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
            >
              <TiltCard
                max={6}
                testId={s.testId}
                className="group h-full p-8 md:p-12 bg-white border border-gray-200 shadow-sm hover:shadow-2xl hover:shadow-gray-300/50 hover:border-[#0047AB]/40 transition-shadow duration-300"
              >
                <div style={{ transform: "translateZ(40px)" }}>
                  <div className="relative overflow-hidden border border-gray-200 mb-8 aspect-video">
                    <img
                      src={s.image}
                      alt={s.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <s.icon className="h-8 w-8 text-[#0047AB] mb-5" strokeWidth={1.5} />
                  <h3 className="font-heading text-2xl font-bold tracking-tight text-[#0A0A0A] mb-4">
                    {s.title}
                  </h3>
                  <p className="text-base leading-relaxed text-[#52525B] mb-6">{s.desc}</p>
                  <ul className="space-y-3">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-start gap-3 text-sm text-[#0A0A0A]">
                        <Check className="h-4 w-4 text-[#0047AB] mt-0.5 shrink-0" strokeWidth={2.5} />
                        <span>{p}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </TiltCard>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
